module.exports = __webpack_public_path__ + "static/media/module_news.652f9080.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_news.svg
// module id = ./src/resources/images/modules/module_news.svg
// module chunks = 0